import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export function isTruthy<T>(thing: T | undefined): thing is T {
  if (!thing) {
    return false
  }

  return true
}
